/*!
 * gate.js — gate(): let a sound go, and press it again
 * © 2026 Rob Canning — GPLv3
 *
 *     gate(s, 0)             let go: s fades out over its own release (env r)
 *                            -- before its effects, so reverb and delay ring
 *                            on -- and the voice runs on, silent
 *     gate(s, 1)             press again: it fades in over its attack (env a)
 *     gate(s, 0, 4)          over 4 beats instead
 *     gate(s, 1, 6, exp3)    along a curve (level()'s: lin exp2 exp3 exp4 log sqrt)
 *     gate([a, b], 0)        several;  gate(all, 1) every one
 *
 * As a keyboard's key: released, the note dies away and the room carries
 * it; pressed, it sounds again -- nothing restarted, nothing remembered. A
 * poly sound gates every voice, and any it starts while closed. hush()
 * opens it again. Synths (synth.js keeps the gate, after the envelope).
 */

import { gateSynth } from "./synth.js";
import { levelArgs } from "./audio/level.js";
import { synthNames } from "./audio/voices.js";
import { secs } from "./beats.js";

/** gate(names, 1 | 0, beats, curve) as a cue. */
export function handleGateCue(ast) {
  const a = levelArgs(ast?.args);
  if (!a.names.length) { console.warn("[gate] which sound? gate(s, 0) / gate(s, 1)"); return; }
  const open = Number(a.numbers[0] ?? 1) !== 0;
  // beats (beats.js); none: the sound's own attack or release
  const time = a.dur ?? a.numbers[1] ?? null;
  const t = time == null ? null : Number(secs(time));
  for (const n of a.names.includes("all") ? synthNames() : a.names) gateSynth(n, open, t, a.curve || "lin");
}
